import { render, staticRenderFns } from "./haokaPhone.vue?vue&type=template&id=a0adfd18&"
import script from "./haokaPhone.vue?vue&type=script&lang=js&"
export * from "./haokaPhone.vue?vue&type=script&lang=js&"
import style0 from "./haokaPhone.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports